import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(timezone);

export const getDateTz = (value) => dayjs(value * 1000).tz(dayjs.tz.guess());
export const getTimestamp = (value) => dayjs(value).unix();
export const formatDate = (value, format) => dayjs(value).format(format);
